import {
  RouteConfig,
} from 'vue-router';

import {
  authRoutes,
} from '@/routes/auth';

export const routes: RouteConfig[] = [
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/',
    name: 'home',
    component: (): Promise<typeof import('*.vue')> => import('../views/Home.vue'),
  },
  {
    path: '/faq',
    name: 'faq',
    component: (): Promise<typeof import('*.vue')> => import('../views/Faq.vue'),
  },
  {
    path: '/tariffs',
    name: 'tariffs',
    component: (): Promise<typeof import('*.vue')> => import('../views/Tariffs.vue'),
  },
  ...authRoutes,
  {
    path: '/profile',
    name: 'profile',
    beforeEnter: (): void => {
      location.assign(`${__config.url.app}/profile`);
    },
  },
];
